export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/alertTriangle.789d3385.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};